export enum UserConsentsTopics {
    UserConsents = 'user-consents',
}
